module.exports = __webpack_public_path__ + "static/video-2-8cba399508c1d55ba44bbd21a6f8ca07.png";